<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>全转录组测序</h1>-->
<!--          <h2 class="mt10">Whole transcriptome sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>全转录组测序</h1>
      <h2 class="mt10">Whole Transcriptome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">全转录组是指特定组织或细胞在特定状态下转录出的所有转录本的总和，包括mRNA和所有的non-coding RNA。全转录组测序应用RNA-Seq技术，通过构建两种文库（small RNA文库和去rRNA的链特异性文库），对四种RNA（miRNA，lncRNA，mRNA，circRNA）的表达及调控关系进行分析。同时分析miRNA，lncRNA，mRNA，circRNA四种RNA的表达及调控关系；验证已知lncRNA，预测novel lncRNA；鉴定已知circRNA的同时，预测新的circRNA及其靶标。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/whole_icon_1.png">
            <p>样本全转录本信息获取</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_2.png">
            <p>基因注释及筛选</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_3.png">
            <p>基因差异表达研究</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/whole_icon_1.png">
            <p>样本全转录本信息获取</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_2.png">
            <p>基因注释及筛选</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_3.png">
            <p>基因差异表达研究</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>HiSeq/Novaseq PE150SE50/SE75DNBSEQ T7 PE100/150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>50个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>20 G Rawdata，10 M reads</p>
        </li> -->
      </ul>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/whole_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/whole_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/whole_transciptome.vue